import { Guid, RecursivePartial } from '@models/base';
import { BaseTaskAction, TaskActionType } from './_base-task-action';

export class TaskActionIntegrationEvent extends BaseTaskAction {
    type: TaskActionType.IntegrationEvent = TaskActionType.IntegrationEvent;
    integrationId?: Guid;
    integrationSetupId?: Guid;
    text?: string;

    constructor(json?: RecursivePartial<TaskActionIntegrationEvent>) {
        super(json);
        this.parseTaskActionIntegrationEvent(json || {});
    }

    parse(json: RecursivePartial<TaskActionIntegrationEvent>): TaskActionIntegrationEvent {
        super.parse(json);
        this.parseTaskActionIntegrationEvent(json);
        return this;
    }

    private parseTaskActionIntegrationEvent(json: RecursivePartial<TaskActionIntegrationEvent>): void {
        TaskActionIntegrationEvent.assignFields<TaskActionIntegrationEvent>(this, json, ['integrationId', 'integrationSetupId', 'text']);
    }
}
